<template>
  <div class="resultCard">
    <div class="tips-box">
      <p class="tips">{{ $t("completed") }}</p>
      <p class="tips">{{ $t("claimYourRewards") }}</p>
    </div>
    <div class="giftCode">
      <p class="code">{{ resultState.giftCode }}</p>
      <a href="javascript:void(0)" class="copy" @click="copyCode">{{
        $t("copy")
      }}</a>
      <p class="copyTips" v-if="resultState.copyStatus">{{ $t("copied") }}</p>
    </div>
    <a
      href="javascript:void(0)"
      class="collectBtn"
      v-if="finishConfig"
      @click="changeResultRoute('collectInfo')"
      >{{ $t("leaveMessage") }}</a
    >
  </div>
</template>
<script setup>
import resultHook from "@/hooks/resultHook";
const {
  resultState,
  copyCode,
  changeResultRoute,
  finishConfig,
  getSurveyAward,
  getCardCode,
  isAward,
} = resultHook();
isAward.value ? getCardCode() : getSurveyAward();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";

.resultCard {
  .giftCode {
    width: 80%;
    height: 300px;
    margin: 20px 0 80px;
    background: #fff;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 80px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (orientation: landscape) {
      height: 300px;
      margin: 20px 0 80px;
      width: 800px;
      border-radius: 15px;
      padding: 80px 20px 20px;
    }
    .code {
      font-size: 24px;
      font-weight: 600;
      color: #999;
      @media screen and (orientation: landscape) {
        font-size: 24px;
      }
    }
    .copyTips {
      font-size: 16px;
      color: #ec8156;
    }
    .copy {
      display: flex;
      width: 500px;
      height: 80px;
      align-items: center;
      justify-content: center;
      background: $btnColor;

      transition: all 0.4s;
      color: #fff;
      border-radius: 10px;
      font-size: 22px;
      margin: 30px 0 20px;
      flex-shrink: 0;
      @media screen and (orientation: landscape) {
        width: 300px;
        height: 70px;
        border-radius: 100px;
        font-size: 22px;
        margin: 30px 0 20px;
      }
      &:hover {
        filter: brightness(1.1);
      }
    }
  }
}
</style>
